import axiosInstance from "../axios_instance";

export async function createOrder(data) {
  try {
    return await axiosInstance.post(`orders/`, data);
  } catch (error) {
    return error;
  }
}

export async function verifyOrder(data) {
  try {
    return await axiosInstance.post(`orders/verify`, data);
  } catch (error) {
    return error;
  }
}

export async function refundOrder(data) {
  try {
    return await axiosInstance.post(`orders/refund`, data);
  } catch (error) {
    return error;
  }
}

export async function getOrders(body) {
  try {
    return await axiosInstance.get("orders/", {
      params: {
        userID: body?.userID,
        serviceName: body?.serviceName,
        getMyServices: body?.getMyServices,
        limit: body?.limit,
        page: body?.page,
      },
    });
  } catch (error) {
    return error;
  }
}

export async function createSubOrder(data) {
  try {
    return await axiosInstance.post(`orders/suborder`, data);
  } catch (error) {
    return error;
  }
}

export async function verifySubOrder(data) {
  try {
    return await axiosInstance.post(`orders/verify-suborder`, data);
  } catch (error) {
    return error;
  }
}
